function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.025 1a5.044 5.044 0 00-5.028 5.432l.243 3.158c.055.708.257 1.371.577 1.96-.804.358-1.895.877-3.026 1.493-1.06.577-1.816 1.657-1.858 2.937-.049 1.51.06 3.793.646 6.428a1.008 1.008 0 101.968-.438c-.544-2.453-.642-4.565-.598-5.925.016-.493.308-.959.805-1.23a40.673 40.673 0 013.448-1.666c.818.61 1.832.968 2.924.968a4.881 4.881 0 002.924-.969c.618.26 1.652.727 2.79 1.318a8.06 8.06 0 012.854-.334 3.646 3.646 0 00-1.233-1.09 43.74 43.74 0 00-3.026-1.492c.32-.589.523-1.252.577-1.96l.243-3.158A5.044 5.044 0 0016.228 1h-.203zm.203 2.018h-.203a3.026 3.026 0 00-3.017 3.26l.243 3.157a2.884 2.884 0 005.75 0l.243-3.158a3.026 3.026 0 00-3.017-3.259z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.336 7.544a3.224 3.224 0 116.42 0l-.16 1.769a3.062 3.062 0 01-5.18 1.924c-.167.087-.373.199-.631.34l-.355.193c-.308.168-.413.392-.413.552a10.16 10.16 0 00.337 2.55 1.01 1.01 0 01-1.952.508A12.174 12.174 0 011 12.314c.004-1.078.689-1.894 1.468-2.317l.304-.166c.256-.14.505-.277.739-.397-.006-.04-.01-.08-.014-.121l-.16-1.769zm4.412-.183l-.161 1.77a1.045 1.045 0 01-2.081 0l-.161-1.77a1.207 1.207 0 112.403 0z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.95 19.162a.757.757 0 10-1.513 0v2.27h-2.269a.757.757 0 000 1.514h2.269v2.27a.757.757 0 101.513 0v-2.27h2.268a.757.757 0 000-1.514H24.95v-2.27z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.387 22.19a6.809 6.809 0 016.806-6.812c3.76 0 6.807 3.05 6.807 6.811A6.809 6.809 0 0124.193 29a6.809 6.809 0 01-6.806-6.81zm6.806-5.298a5.296 5.296 0 00-5.294 5.297 5.296 5.296 0 005.294 5.297 5.296 5.296 0 005.294-5.297 5.296 5.296 0 00-5.294-5.297z",
  fill: "currentColor"
})));